import { checkModule } from '../utils';
import { useLoggedInUser } from './useLoggedInUser';

export const useModule = (module: string) => {
  const { modules } = useLoggedInUser();
  const hasAccess = checkModule(module, modules);
  return hasAccess;
};
